import { ErrorHandler, Inject, Injectable, Injector } from '@angular/core';
import { environment } from '@env/environment';
import { LoggerService } from './logger/logger.service';

@Injectable({
  providedIn: 'root',
})
export class CustomErrorHandler implements ErrorHandler {
  constructor(@Inject(Injector) private readonly injector: Injector) {}

  private get loggerService(): LoggerService {
    return this.injector.get(LoggerService);
  }

  handleError(error: any) {
    if (!error) {
      return;
    }
    this.loggerService.logError(error);
    if (!environment.production) {
      throw error;
    }
  }
}
